import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircle, Loader2 } from 'lucide-react';
import { useLang } from '../i18n';
import { apiFetch } from '../utils/operations';

export default function TravellerAccessPage() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState('validating');
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    const token = params.get('token') || '';
    if (!token) { setState('invalid'); return; }
    apiFetch('/traveller/auth/verify', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
    }).then(() => navigate('/my-trip', { replace: true })).catch(() => {
      window.history.replaceState({}, '', '/my-trip/access');
      setState('invalid');
    });
  }, [navigate, params]);

  return <main data-testid="traveller-access-page" className="grid min-h-[70vh] place-items-center bg-eco-cream px-5 pt-24">
    <section className="w-full max-w-md rounded-2xl border border-eco-ink/10 bg-white p-8 text-center shadow-sm">
      {state === 'validating' ? <><Loader2 className="mx-auto animate-spin text-eco-green" /><p className="mt-4 text-sm text-eco-ink/60">{t('traveller.access.validating')}</p></> : <><AlertCircle className="mx-auto text-red-500" /><h1 className="mt-4 text-xl font-semibold text-eco-ink">{t('traveller.access.invalid')}</h1><Link to="/my-trip" className="eco-btn-primary mt-6">{t('traveller.link.again')}</Link></>}
    </section>
  </main>;
}
